<template>
    <div>
        <div class="columns is-multiline m-b-15 border-bottom">
            <div class="column is-full has-text-left">
                <a 
               
                class="has-text-danger"
                @click="deleteVar">
                    <b-icon icon="times" size="is-small"></b-icon>
                    Delete
                </a>
                <b-field label="Precio especial" class="m-t-2">
                    <b-switch 
                    v-model="data.hasDifPricing"
                    @input="updateRightField('a', 'a', false)">
                    </b-switch>
                </b-field>
            </div>

            <div v-if="newVar" v-for="x in attributes" class="column is-one-fifth"  :key="x.title">
                <b-field :label="x.title ? x.title : 'Atributo'">
                    <b-select 
                        placeholder="Elige un valor" 
                        v-model="data[x.title]">
                        <option v-for="v in x.values" :value="v.id" :key="v.id">{{v.title}}</option>
                    </b-select>
                </b-field>
            </div>

            <div v-if="!newVar" v-for="x in attributes" class="column is-one-fifth"  :key="x.title">
                <b-field :label="x.title ? x.title : 'Atributo'">
                         <b-select 
                         placeholder="Elige un valor"
                         :value="modelSyncVal(x.title)"
                         v-on:input="updateRightField(x.title, $event, true)">
                            <option v-for="v in x.values" :value="v.id" :selected="data.values.includes(v.id)"  :key="v.id">{{v.title}} </option>
                        </b-select>
                </b-field>
            </div>

            <div v-if="data.hasDifPricing" class="column is-one-fifth">
                <b-field label="Precio">
                    <b-numberinput 
                    v-model="data.price" 
                    min="0"
                    step="0.01"
                    :controls="false"
                    @input="updateRightField('a', 'a', false)"
                    >
                    </b-numberinput>
                </b-field>
            </div>  

            <div v-if="data.hasDifPricing" class="column is-one-fifth">
                <b-field label="Costo">
                    <b-numberinput 
                    v-model="data.cost" 
                    min="0" 
                    step="0.01"
                    :controls="false"
                    @input="updateRightField('a', 'a', false)"
                   >
                    </b-numberinput>
                    
                </b-field>
                
            </div>
            <div v-if="data.hasDifPricing" class="column is-one-fifth">
                <b-field label="Comparar a ">
                    <b-numberinput 
                    v-model="data.compareAt" 
                    min="0" 
                    step="0.01"
                    :controls="false"
                    @input="updateRightField('a', 'a', false)"
                   >
                    </b-numberinput>
                    
                </b-field>
                
            </div>

        </div>
    </div>
</template>


<script>
import {patchHandler, debounce, deleteHandler} from "./../../../../services/http.js"

export default {
    props:{
        data:{
            type:Object,
            default:new Object({})
        },
        newVar:{
            type:Boolean,
            default:false
        },
        index:{
            type:Number,
            default:0
        },
        attributes:{
            type:Array,
            default:[]
        },
        variantDetail:{
            type:String,
            default:[]
        },
        index:{
            type:Number,
            default:0
        }
    },
    data(){
        return{
            valuesDetailInternal:[]
        }
    },

    methods:{
         modelSyncVal(title){
            let el = null
            this.valuesDetailInternal.forEach(element => {
                if(element[title] != null || element[title]!= undefined){
                    el = element[title]
                    console.log(el)
                    
                }
            })
            if(el != null || el != undefined){
            return el
            }
        },
        updateRightField: debounce(async function(attrName, val, isValue){
            if(isValue){
                let el = this.data.valuesDetail.find(element => element[attrName])
                if (el){
                    let deleteI = this.data.values.indexOf(el[attrName])
                    this.data.values.splice(deleteI, 1)
                    el[attrName] = val
                }
                this.data.values.push(val)
            }
            let error={
                resource:"toast"
            }
            let success={
                resource:"toast"
            }
            let url = this.variantDetail.replace("0000", this.data.id)
            let response = await patchHandler(url, this.data, {success, error})
        }, 500),
        async deleteVar(){
            if(!this.newVar){
                let error={
                    resource:"toast"
                }
                let success={
                    resource:"toast"
                }
                let url = this.variantDetail.replace("0000", this.data.id)
                let response = await deleteHandler(url, {success, error})
                this.$emit("reFetchVariants")
                this.$emit("getProd")
            } else {
                this.$emit("deleteNewVar", this.index)
            }
            
        }
        
    },
    created(){

        this.valuesDetailInternal = this.data.valuesDetail
    }

}
</script>

<style lang="scss" scoped>
.border-bottom{
    border-bottom: 0.8px #ddd solid;
}
</style>
